<template>
    <svg
        fill="none"
        height="19"
        viewBox="0 0 19 19"
        width="19"
        xmlns="http://www.w3.org/2000/svg">
        <rect
            fill="white"
            height="18.5"
            rx="1.85"
            width="18.5"
            x="0.25"
            y="0.25" />
        <rect
            height="18.5"
            rx="1.85"
            stroke="currentColor"
            stroke-width="0.5"
            width="18.5"
            x="0.25"
            y="0.25" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
